import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Button,
  CircularProgress,
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

type AssetActionsProps = {
  onEdit: () => void;
  onDelete: () => void | Promise<void>;
  canEdit: boolean;
  canDelete: boolean;
  deleteLoading?: boolean;
};

export const AssetActions = ({
  onEdit,
  onDelete,
  canEdit,
  canDelete,
  deleteLoading = false,
}: AssetActionsProps) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    onDelete();
    setDeleteDialogOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <Stack direction='row' gap={1}>
      {canDelete && (
        <Button
          variant='outlined'
          color='secondary'
          startIcon={deleteLoading ? <CircularProgress size={16} /> : <DeleteIcon />}
          onClick={handleDeleteClick}
          disabled={deleteLoading}
        >
          {deleteLoading ? 'Deleting...' : 'Delete'}
        </Button>
      )}

      {canEdit && (
        <Button variant='contained' color='secondary' startIcon={<EditIcon />} onClick={onEdit}>
          Edit
        </Button>
      )}

      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth='sm' fullWidth>
        <DialogTitle>Delete Asset</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this asset? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleDeleteCancel} disabled={deleteLoading}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='error'
            onClick={handleDeleteConfirm}
            disabled={deleteLoading}
            startIcon={deleteLoading ? <CircularProgress size={16} /> : undefined}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};
